// extracted by css-extract-rspack-plugin
export default {"root":"_3WyT","container":"zPG8M"};